import React from 'react'
import {
  Button,
  Grid,
  IconButton,
  Typography,
  withStyles
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Page } from 'components'
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ReactGA from "react-ga4";

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100vh',

    gap: 10
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    width: '100%',
    maxWidth: '500px',
    textAlign: 'center',
  },
  code: {
    color: '#D2222D',
  }
})

const Youcom = (props) => {
  const { classes } = props

  const CODE = 'QUIEROYC'

  const handleCopy = () => {
    navigator.clipboard.writeText(CODE);

    toast.success('Código copiado para a área de transferência! 🤩')
  }

  const handleClick = () => {
    ReactGA.event({
      category: "Link Externo",
      action: "open_link_youcom",
      label: "Youcom",
    });

    window.open("https://www.youcom.com.br/", "_blank");
  };

  return (
    <Page title="Campanha Youcom">
      <Grid container className={[classes.root, classes.flexColumn]}>
        <Grid item className={classes.flexColumn} style={{ margin: 20, gap: 10 }}>
          <Typography variant="h4" style={{ marginBottom: 10, textAlign: 'center' }}>
            A Youcom tem um presente especial para você 🎁.
          </Typography>

          <Typography className={classes.text}>
            Com o cupom <b>{CODE}</b> tem <b>R$ 50</b> de desconto nas compras acima de R$ 199 pelo site, App ou lojas físicas.
          </Typography>

          <Typography className={classes.text}>
            Para o site ou App pode aplicar o cupom ao finalizar a compra e na loja física só apresentar a tela do App.
          </Typography>

          <Typography className={classes.text}>
            Cupom válido até <b>31/12</b>.
          </Typography>

          <Typography className={classes.text}>
            Acesse o site e comece a aproveitar 🎉
          </Typography>
        </Grid>

        <Grid item className={classes.flexRow}>
          <Typography variant="h3" className={classes.code}>
            {CODE}
          </Typography>

          <IconButton onClick={handleCopy} aria-label="copy">
            <FilterNoneIcon style={{ color: '#D2222D' }} />
          </IconButton>
        </Grid>

        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            endIcon={<OpenInNewIcon />}
            onClick={handleClick}
          >
            Ir para o site
          </Button>
        </Grid>

        <Typography variant="caption" className={classes.text} style={{ marginTop: 10 }}>
          *Regras e regulamento no site Youcom
        </Typography>
      </Grid>
    </Page>
  )
}

Youcom.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication
  return {
    loggingIn
  }
}
const connectedYoucomPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(Youcom))
)
export { connectedYoucomPage as Youcom }
